var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.$parent.inline ? 'span' : 'div',{tag:"div",class:[_vm.baseCss, _vm.$parent.inline ? ['inline-block', 'align-middle'] : null, ("text-" + _vm.fontSize), _vm.bold ? 'font-semibold' : null, 'truncate']},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20ae1488","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/bcq-ui/components/stats-label/stats-label.vue
// module id = null
// module chunks = 